<template>
  <div :class="{'counter': true, 'invalid': !lengthValid}">
    <span>
      {{ textLength }} / {{ getMaxTextLength }}
    </span>
  </div>
</template>

<script>
export default {
  methods: {
    /**
     * Emits status change.
     * @param {Boolean} valid If count is valid
     */
    emitChange (valid) {
      this.$emit('change', { valid })
    }
  },

  computed: {
    /**
     * Checks if length is valid
     * @returns {Boolean}
     */
    lengthValid () {
      return this.textLength <= this.getMaxTextLength
    },

    /**
     * Determines max text length based on content type or given number
     * @returns {Number}
     */
    getMaxTextLength () {
      if (typeof this.maxTextLength === 'number') {
        return this.maxTextLength
      }

      switch (this.maxTextLength) {
        case 'twitterTweet':
          return 280

        default:
          return -1
      }
    }
  },

  // Emit pn mount to get initial value
  mounted () {
    this.emitChange(this.lengthValid)
  },

  watch: {
    lengthValid: {
      handler: function (newV, oldV) {
        // When validity changes; emit event
        this.emitChange(this.lengthValid)
      }
    }
  },

  props: {
    textLength: {
      type: Number,
      required: true,
      default: 0  
    },
    maxTextLength: {
      default: 'twitterTweet'
    },
  }
}
</script>

<style scoped>
.counter {
  font-size: 10px;
}
.counter.invalid {
  color: red;
}
</style>





// WEBPACK FOOTER //
// src/components/standard/display/TextCounter.vue?150a8796